export interface IBulkActionItem {
  inboxItemId: number
  externalItemIdentifier: string
}

export class BulkActionItem implements IBulkActionItem {
  public inboxItemId: number
  public externalItemIdentifier: string
}
